export default __webpack_public_path__ + "static/cab_backsplash-3cf29e9dbc4c7894cc8f0f4a84e2d029.jpeg";